'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["height", "maxHeight"],
  _excluded2 = ["inputWidth", "minHeight", "resize", "rows", "shrink"];
import { PureComponent } from 'react';
import styled from 'styled-components';
import { getTextHeight } from '../utils/MeasureText';
import { toPx } from '../utils/Styles';
import ShareInput from '../decorators/ShareInput';
import MeasureInput from '../decorators/MeasureInput';
import UITextArea from './UITextArea';
import memoizeOne from 'react-utils/memoizeOne';
import Controllable from '../decorators/Controllable';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledTextArea = styled(props => {
  const rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(UITextArea, Object.assign({}, rest));
}).withConfig({
  displayName: "UIExpandingTextArea__StyledTextArea"
})(["max-height:", " !important;overflow:", " !important;&&{transition:none;}"], ({
  maxHeight
}) => maxHeight < Infinity && toPx(maxHeight), ({
  height,
  maxHeight
}) => height > maxHeight ? 'auto' : 'hidden');
const getStyle = height => ({
  height
});
class UIExpandingTextArea extends PureComponent {
  constructor(props) {
    super(props);
    this.setHeight = initial => {
      const {
        inputRef,
        minHeight,
        shrink
      } = this.props;
      const textAreaNode = inputRef.current;
      if (!textAreaNode) return;
      const textHeight = getTextHeight(textAreaNode);
      let newHeight;
      if (shrink) {
        newHeight = Math.max(minHeight, textHeight);
      } else {
        // Ensure that we don't reduce height below what the user set by manually resizing
        const measuredHeight = initial ? 0 : textAreaNode.getBoundingClientRect().height;
        newHeight = Math.max(minHeight, textHeight, measuredHeight);
      }
      if (this.state.height !== newHeight) {
        this.setState({
          height: newHeight
        });
      }
    };
    this.state = {
      height: null
    };
    this._getStyle = memoizeOne(getStyle);
    this._hasUpdated = false;
  }
  componentDidUpdate(prevProps, prevState) {
    // ⚠️ This condition prevents infinite loops! ⚠️
    if (prevState.height === this.state.height) {
      this.setHeight(!this._hasUpdated);
      this._hasUpdated = true;
    }
  }
  render() {
    const _this$props = this.props,
      {
        // inputWidth is used by MeasureInput solely to trigger updates

        resize,
        shrink
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded2);
    const {
      height
    } = this.state;
    return /*#__PURE__*/_jsx(StyledTextArea, Object.assign({}, rest, {
      resize: shrink ? false : resize,
      style: this._getStyle(height),
      height: height
    }));
  }
}
UIExpandingTextArea.displayName = 'UIExpandingTextArea';
UIExpandingTextArea.defaultProps = Object.assign({}, UITextArea.defaultProps, {
  maxHeight: Infinity,
  minHeight: 0,
  shrink: false
});
export default Controllable(ShareInput(MeasureInput(UIExpandingTextArea)));